import filter from 'lodash/filter';
import head from 'lodash/head';

export class PrivacyPolicyService {
	constructor($resource, ApiService, BreadcrumbService) {
		'ngInject';

		this.$resource = $resource;
		this.apiService = ApiService;
		this.breadcrumbService = BreadcrumbService;

		this.privacyPolicyResourceUrl = this.apiService.getResourceUrl('privacy-policy');

		this.privacyPolicyResource = this.$resource(this.privacyPolicyResourceUrl);
	}

	_getPrivacyPolicyDetailsObject(values) {
		let details = filter(values, ['name', 'PrivacyPolicy']);
		this.breadcrumbService.setPageBreadcrumbs(head(details).breadcrumb);
		return _getContentData(head(details).values);

		function _getContentData(data) {
			return data.map(({description}) => ({description}))
		}		
	}

	getPrivacyPolicyDetails() {
		const promise = this.privacyPolicyResource.get().$promise;

		return promise.then(details => ({
			details: this._getPrivacyPolicyDetailsObject(details.data)
		})).catch((error) => {
			throw this.apiService.getErrorMessage(error);
		});
	}
}


// WEBPACK FOOTER //
// ./src/app/components/privacy-policy/privacy-policy.service.js